import { clsx } from "clsx";
import _ from "lodash";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export const isActive = (location, path) => {
    return location === path || location.startsWith(`${path}/`);
};
export const isActiveExact = (location, path) => new RegExp(path + "$").test(location.replace(/^\/[\w0-9-]+\/[\w0-9-]+/, ""));
export function percentageOf(part, total) {
    if (total === 0) {
        return 0;
    }
    return (part * 100) / total;
}
export function escapeRegExp(value) {
    if (typeof RegExp.escape === "function") {
        return RegExp.escape(value);
    }
    return _.escapeRegExp(value);
}
